import gql from 'graphql-tag';

// Query used to get the list of modules linked to the current dataname.
export const getLocationWithSettings = gql`
	query getLocationWithSettings($id: ID) {
		location(id: $id) {
			id
			name
			integrateCC

			gratuitySetting {
				allowServerManageGratuity
				collectGratuity
				gratuityEntryApproach
				includeOnPrintedCheck
				includeSuggestions
				tipAlert
				tipAlertPercentage
				tipAlertAccessLevel
				lavupayServerManageTips
				lavupayServerManageTipsMinimumAccessLevel
			}

			tapToPayIphoneSetting {
				enableAdyenTapToPayIphone
			}

			preAuthSetting {
				preAuthOnNewTab
				defaultAmount
			}

			signatureSetting {
				captureSignature
				captureSignatureIphone
			}

			allowOfflineCreditCardTransactions

			lavuPayBatchSetting {
				allowBatchingInFrontEnd
				autoBatch
				batchSchedule {
					rrule
				}
			}

			verifoneBatchSetting {
				allowBatchingInFrontEnd
				autoBatch
				batchSchedule {
					rrule
				}
			}

			adyenBatchSetting {
				allowBatchingInFrontEnd
				autoBatch
				batchSchedule {
					rrule
				}
			}

			receiptSetting {
				includeCreditCardTransactionDetails
				includeLocationAddress

				printCustomerCreditCardReceipt
				printMerchantCreditCardReceipt

				printCustomerPreAuthorizationReceipt
				printMerchantPreAuthorizationReceipt

				printCustomerRefundReceipt
				printMerchantRefundReceipt

				printCustomerVoidReceipt
				printMerchantVoidReceipt
			}

			transactionSetting {
				creditCardTransactionType
				enableAdyenAutoApproveForRefundsAndVoids
			}

			cardReaderSetting {
				lavuPayDeviceType
			}
		}
	}
`;

export const updateLocationSettings = gql`
	mutation updateLocationSettings($input: LocationSettingsInput) {
		updateLocationSettings(input: $input) {
			id
			name
			integrateCC

			gratuitySetting {
				allowServerManageGratuity
				collectGratuity
				gratuityEntryApproach
				includeOnPrintedCheck
				includeSuggestions
				tipAlert
				tipAlertPercentage
				tipAlertAccessLevel
				lavupayServerManageTips
				lavupayServerManageTipsMinimumAccessLevel
			}

			tapToPayIphoneSetting {
				enableAdyenTapToPayIphone
			}

			preAuthSetting {
				preAuthOnNewTab
				defaultAmount
			}

			signatureSetting {
				captureSignature
				captureSignatureIphone
			}

			allowOfflineCreditCardTransactions

			lavuPayBatchSetting {
				allowBatchingInFrontEnd
				autoBatch
				batchSchedule {
					rrule
				}
			}

			verifoneBatchSetting {
				allowBatchingInFrontEnd
				autoBatch
				batchSchedule {
					rrule
				}
			}

			adyenBatchSetting {
				allowBatchingInFrontEnd
				autoBatch
				batchSchedule {
					rrule
				}
			}

			receiptSetting {
				includeCreditCardTransactionDetails
				includeLocationAddress

				printCustomerCreditCardReceipt
				printMerchantCreditCardReceipt

				printCustomerPreAuthorizationReceipt
				printMerchantPreAuthorizationReceipt

				printCustomerRefundReceipt
				printMerchantRefundReceipt

				printCustomerVoidReceipt
				printMerchantVoidReceipt
			}

			transactionSetting {
				creditCardTransactionType
				enableAdyenAutoApproveForRefundsAndVoids
			}

			cardReaderSetting {
				lavuPayDeviceType
			}
		}
	}
`;

export const updateBusinessContactSettings = gql`
	mutation updateBusinessContactSettings($input: BusinessContactSettingsInput) {
		updateBusinessContactSettings(input: $input) {
			businessPrimaryContact
			businessEmailId
			businessPhone
			businessAddress
			businessCity
			businessState
			businessZip
		}
	}
`;

export default {
	getLocationWithSettings,
	updateLocationSettings,
	updateBusinessContactSettings,
};
